import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaEnvelope, FaLock, FaArrowLeft, FaShieldAlt } from 'react-icons/fa';
import { useAuth } from '../contexts/AuthContext';
import logo from '../assets/logo.svg';
import './Login.css';

const Login = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(formData.email, formData.password);

    if (result.success) {
      navigate('/admin');
    } else {
      setError(result.message);
    }

    setLoading(false);
  };

  return (
    <div className="login-page">
      {/* Background Gradient */}
      <div className="login-background-gradient"></div>

      {/* Back Button */}
      <button className="login-back-btn" onClick={() => navigate('/')}>
        <FaArrowLeft />
        <span>Back</span>
      </button>

      <div className="login-container">
        {/* Logo & Header Section */}
        <div className="login-header">
          <div className="login-logo">
            <div className="login-logo-wrapper">
              <img src={logo} alt="App Logo" />
            </div>
          </div>
          <div className="login-welcome">
            <h1>Welcome back</h1>
            <p className="login-subtitle">Enter your credentials to access the admin dashboard</p>
          </div>
        </div>

        {/* Form Card */}
        <div className="login-card">
          {error && (
            <div className="login-alert login-alert-error">
              <div className="login-alert-icon">!</div>
              <div className="login-alert-content">
                <p className="login-alert-title">Authentication failed</p>
                <p className="login-alert-description">{error}</p>
              </div>
            </div>
          )}

          <form onSubmit={handleSubmit} className="login-form">
            <div className="login-form-group">
              <label htmlFor="email" className="login-label">
                Email
              </label>
              <div className="login-input-wrapper">
                <div className="login-input-icon">
                  <FaEnvelope />
                </div>
                <input
                  id="email"
                  type="email"
                  className="login-input"
                  placeholder="name@example.com"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  required
                  autoComplete="email"
                />
              </div>
            </div>

            <div className="login-form-group">
              <label htmlFor="password" className="login-label">
                Password
              </label>
              <div className="login-input-wrapper">
                <div className="login-input-icon">
                  <FaLock />
                </div>
                <input
                  id="password"
                  type="password"
                  className="login-input"
                  placeholder="Enter your password"
                  value={formData.password}
                  onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                  required
                  autoComplete="current-password"
                />
              </div>
            </div>

            <button type="submit" className="login-button" disabled={loading}>
              {loading ? (
                <>
                  <div className="login-spinner" />
                  <span>Signing in...</span>
                </>
              ) : (
                'Sign in'
              )}
            </button>
          </form>
        </div>

        {/* Footer */}
        <div className="login-footer">
          <div className="login-footer-badge">
            <FaShieldAlt />
            <span>Secure admin access</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
